<template>
  <div
    v-if="urls.length || isEditable"
    class="navigation-group-block"
    :aria-label="`Listar ${urls.length} objekt`"
  >
    <sub-heading
      v-if="heading || isEditable"
      :v-edit-heading="'NavigationHeading'"
      :heading="heading"
    />
    <div class=" row-1_lg-3_md-2">
      <navigation-block
        v-for="(block, blockIndex) in urls"
        :key="blockIndex"
        v-no-edit
        :button-label="block.label"
        :url="block.url"
        :target="block && block.target"
      />
    </div>
  </div>
</template>
<script>

export default {
  name: "NavigationGroupBlock",
  props: {
    content: {
      type: Array,
      default: () => []
    },
    heading: {
      type: String,
      default: ''
    },
    urls: {
      type: Array,
      default: () => []
    },
  },
 }
</script>
<style lang="scss">
  .navigation-group-block {
    @include default-margin-top();
  }
</style>
